const SET_DATA_ALERT = "app/SET_DATA_ALERT";

function setDataAlert(data) {
  console.log("setDataAlert", SET_DATA_ALERT);
  return {
    type: SET_DATA_ALERT,
    payload: {
      items: data,
    },
  };
}

export { SET_DATA_ALERT, setDataAlert };
